import { MEDIA_SM } from 'const'
import styled from 'styled-components'

export const Container = styled.div<{ $layoutHeight: number }>`
  display: flex;
  flex-direction: column;
  gap: 12px;
  box-shadow: rgb(170, 170, 170) 0 0 4px 0;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.95);
  padding: 10px;
  // for scroll in table
  flex: 1;
  overflow: hidden;
  min-height: ${({ $layoutHeight }) => {
    if ($layoutHeight < 300) return 'auto'
    return '220px'
  }};
`

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  // for scroll in table
  flex: 1;
  overflow: auto;
  min-height: 0;
  padding-bottom: 8px;
`

export const Filters = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 8px;
`

export const EventTypeFilter = styled.div`
  width: 110px;
`

export const SeasonFilter = styled.div`
  width: 110px;
`

export const TitleContainer = styled.div<{ $width: number }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;

  flex-direction: ${({ $width }) => {
    if ($width > MEDIA_SM) return 'row'
    return 'column'
  }};
`

export const Title = styled.h5`
  font-size: 18px;
  font-weight: 600;
  line-height: 1.4;
`

export const Links = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`

export const Link = styled.a`
  text-decoration: none;
  font-size: 12px;
  font-weight: 400;
  color: rgb(28, 129, 230);
  line-height: 1.4;

  &:hover {
    text-decoration: underline;
  }
`
